export default {
  required: value => (value ? undefined : 'Required'),
  lengthMax16: ({length}) => length > 16 ? 'Too long!' : undefined,
  validString: value => !/^[\w]+$/.test(value) ? 'Only letters, numbers and underscores allowed!' : undefined,
  email: value =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
      ? 'Invalid email address'
      : undefined,
  passwordLength: ({length}) => length < 8 ? 'Password too short!' : undefined,
  samePassword: (pw_re, { pw }) => pw !== pw_re ? 'Passwords must match!' : undefined
}


// WEBPACK FOOTER //
// ./src/validator.js